// constants.ts
import { DesignSystem } from "@adornis/chemistry/elements/theming/design";
var baseFontSize = 16;
var baseFontSizeTablet = 12;
var baseFontSizeMobile = 11;
var baseFontSizeMobileSmall = 10;
var fontFamily = "'Work Sans'";
var fontFamilyText = "Inter";
var geSpacing = {
  ...DesignSystem.currentTheme.getValue().spacing,
  landing: "192px"
};
export {
  baseFontSize,
  baseFontSizeMobile,
  baseFontSizeMobileSmall,
  baseFontSizeTablet,
  fontFamily,
  fontFamilyText,
  geSpacing
};
